import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-modalities.tsx
var LazyCourseModalities = lazy(() => import("./course-modalities-Crc-KXnb.js").then((n) => n.n).then((module) => ({ default: module.CourseModalities })));
function CourseModalities({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-modalities" }),
		children: /* @__PURE__ */ jsx(LazyCourseModalities, { ...props })
	});
}
function CourseModalitiesContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-modalities" }),
		children: /* @__PURE__ */ jsx(LazyCourseModalities, { ...props })
	});
}
var useCourseModalitiesContent = () => {
	return useMemo(() => ({ courseModalities: { component: CourseModalitiesContent } }), []);
};
//#endregion
export { CourseModalities, useCourseModalitiesContent };
